@import "../../global/normalize.css";

:host(.ic-link) .link,
:host(.ic-link) ::slotted(a) {
  color: var(--ic-link-text);
  text-decoration: underline;
  font-weight: var(--ic-font-weight-bold);
  transition: var(--ic-easing-transition-fast);
}

:host(.ic-link) .link:visited,
:host(.ic-link) ::slotted(a:visited),
:host(.ic-link) .link:visited:hover,
:host(.ic-link) ::slotted(a:visited:hover),
:host(.ic-link) .link:visited:active,
:host(.ic-link) ::slotted(a:visited:active),
:host(.ic-link) .link:visited:focus,
:host(.ic-link) ::slotted(a:visited:focus) {
  color: var(--ic-link-text-visited);
}

:host(.ic-link) .link:hover {
  color: var(--ic-link-text-hover);
}

:host(.ic-link) .link:active {
  color: var(--ic-link-text-pressed);
}

:host(.ic-link) .link:focus {
  color: var(--ic-link-text-focused);
}

:host(.ic-link-monochrome) .link:hover {
  color: var(--ic-link-text-hover-monochrome);
}

:host(.ic-link-monochrome) .link:active {
  color: var(--ic-link-text-pressed-monochrome);
}

:host(.ic-link-monochrome) .link:focus {
  color: var(--ic-link-text-focused-monochrome);
}

:host(.ic-link) .link:hover,
:host(.ic-link) .link:focus,
:host(.ic-link) ::slotted(a:hover),
:host(.ic-link) ::slotted(a:focus) {
  outline: none;
  border-bottom: 0.25rem solid !important;
  margin-bottom: -0.25rem !important;
  text-decoration: none;
}

@supports (text-underline-offset: 10%) {
  :host(.ic-link) .link:hover,
  :host(.ic-link) .link:focus,
  :host(.ic-link) ::slotted(a:hover),
  :host(.ic-link) ::slotted(a:focus) {
    text-decoration-line: underline;
    text-decoration-thickness: 25%;
    text-underline-offset: 10%;
    border-bottom: 0 !important;
    margin-bottom: 0 !important;
  }
}

:host(.ic-link) .link:active,
:host(.ic-link) .link:focus:active,
:host(.ic-link) .link:visited:active,
:host(.ic-link) ::slotted(a:active),
:host(.ic-link) ::slotted(a:focus:active),
:host(.ic-link) ::slotted(a:visited:active) {
  text-decoration: none;
}

.ic-link-open-in-new-icon {
  vertical-align: middle;
  margin-left: var(--ic-space-xxs);
}

.ic-link-open-in-new-icon > svg {
  width: var(--ic-space-md);
  height: var(--ic-space-md);
  fill: var(--ic-link-icon-launch);
}

.link:visited > .ic-link-open-in-new-icon > svg {
  fill: var(--ic-link-icon-launch-visited);
}

:host(.ic-link-monochrome) .link,
:host(.ic-link-monochrome) ::slotted(a) {
  color: var(--ic-link-text-monochrome);
}

:host(.ic-link-monochrome) .link:visited,
:host(.ic-link-monochrome) ::slotted(a:visited),
:host(.ic-link-monochrome) .link:visited:hover,
:host(.ic-link-monochrome) ::slotted(a:visited:hover),
:host(.ic-link-monochrome) .link:visited:active,
:host(.ic-link-monochrome) ::slotted(a:visited:active),
:host(.ic-link-monochrome) .link:visited:focus,
:host(.ic-link-monochrome) ::slotted(a:visited:focus) {
  color: var(--ic-link-text-visited-monochrome);
}

:host(.ic-link-monochrome) .link > .ic-link-open-in-new-icon > svg {
  fill: var(--ic-link-icon-launch-monochrome);
}

:host(.ic-link-monochrome) .link:visited > .ic-link-open-in-new-icon > svg {
  fill: var(--ic-link-icon-launch-visited-monochrome);
}

:host(.breadcrumb-link) .link {
  display: var(--breadcrumb-link-display);
  align-items: var(--breadcrumb-link-align-items);
  gap: var(--breadcrumb-link-gap);
}

:host(.breadcrumb-link) .link ::slotted(.back-icon) {
  height: var(--ic-space-lg);
  width: var(--ic-space-lg);
}

:host(.breadcrumb-link.current-page) a,
:host(.breadcrumb-link.current-page) ::slotted(a) {
  font-weight: normal;
  color: inherit;
  text-decoration: none;
  display: flex;
  align-items: center;
}

:host(.breadcrumb-link.current-page) .link,
:host(.breadcrumb-link.current-page) ::slotted(a:focus) {
  outline: var(--ic-hc-focus-outline);
  text-decoration: none;
}

:host(.breadcrumb-link.current-page) .link:visited {
  color: var(--ic-color-text-primary);
}

/* Footer link */

:host(.footer-link) ::slotted(a) {
  color: var(--ic-footer-link) !important;
}

:host(.footer-link) .ic-link-open-in-new-icon > svg {
  fill: var(--ic-footer-icon) !important;
}

/** High Contrast **/
@media (forced-colors: active) {
  :host(.ic-link) .ic-link-open-in-new-icon > svg {
    fill: currentcolor !important;
  }
}

@media (prefers-reduced-motion: reduce) {
  :host(.ic-link) .link,
  :host(.ic-link) ::slotted(a) {
    transition: none;
  }
}
